import { call, all } from "redux-saga/effects";

import {
    fetchUserInfo,
    fetchSearchRecords,
    fetchWarrantyInfo,
    fetchContractorInfo,
    deleteSubmittedWarrantyAdmin,
    deleteSubmittedShoppingCartAdmin,
} from "./components/AdminDashboard/saga";
import { operationalReportWatcher } from "./components/OperationalReport/saga";
import { superAdminWatcher } from "./components/SuperAdmin/saga";
import { fetchDraftList, deleteDraftItem } from "./components/DraftRegistration/saga";
import { fetchSubmittedList } from "./components/SubmittedWarranties/saga";
import {
    fetchData,
    fetchSavedFormLayoutData,
    fetchSavedFormData,
    fetchSavedFormDataAndCopy,
    saveDraftItem,
    updateDraftForm,
    autoSaveForm,
    fetchBuildingAddressCountryCode,
    fetchMailAddressCountryCode,
    getReviewAndPayData,
    getErrorResponseOnNavChange,
    saveTemplate,
    getTemplates,
    deleteTemplates,
    getTemplatesById,
    checkEditable,
    fetchMergeFormDatatoStore,
    validateBuildingAddr,
    modifySubmittedWarranty,
    GetContractorFormSetting,
    warrantyVarianceWatcher
} from "./components/DynamicForm/saga";
import {
    beginTransaction,
    validateTransaction,
    generateFullWarrantyReport,
    generateSummaryWarrantyReport,
    downloadSummaryPDF
} from "./components/ThankYou/saga";

import {
    multipleWarrantiesThankYou,
} from "./components/MultipleWarrantiesThankYou/saga";

import {
    myCartWatcher,
} from "./components/MyCart/saga";
import { fetchselectAddressCode } from "./widgets/typeAhead/saga";

import { fetchPropertyManagerList } from "./widgets/PropertyManagerTypeAhead/saga";

export default function* rootWatchers() {
    yield all([
        call(fetchUserInfo),
        call(fetchSearchRecords),
        call(fetchContractorInfo),
        call(fetchWarrantyInfo),
        call(fetchDraftList),
        call(fetchSubmittedList),
        call(deleteDraftItem),
        call(fetchData),
        call(fetchSavedFormLayoutData),
        call(fetchSavedFormData),
        call(fetchSavedFormDataAndCopy),
        call(saveDraftItem),
        call(updateDraftForm),
        call(autoSaveForm),
        call(fetchMailAddressCountryCode),
        call(fetchBuildingAddressCountryCode),
        call(fetchselectAddressCode),
        call(getReviewAndPayData),
        call(getErrorResponseOnNavChange),
        call(beginTransaction),
        call(validateTransaction),
        call(saveTemplate),
        call(getTemplates),
        call(deleteTemplates),
        call(getTemplatesById),
        call(checkEditable),
        call(fetchMergeFormDatatoStore),
        call(validateBuildingAddr),
        call(modifySubmittedWarranty),
        call(deleteSubmittedWarrantyAdmin),
        call(deleteSubmittedShoppingCartAdmin),
        call(generateFullWarrantyReport),
        call(generateSummaryWarrantyReport),
        call(downloadSummaryPDF),
        call(GetContractorFormSetting),
        call(operationalReportWatcher),
        call(superAdminWatcher),
        call(multipleWarrantiesThankYou),
        call(myCartWatcher),
        call(fetchPropertyManagerList),
        call(warrantyVarianceWatcher),
    ]);
}
